<template>
  <!-- Analysis -->
  <div class="whole-page-long">
    <div class="navbar-div">
      <Navbar
        analysis="CREATEREPORT"
        :colorTheme="colorTheme"
        :user="user"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>

    <div class="row f-row justify-content-center h-100">
      <div class="col col-12 f-row" style="padding: 0 10px 0 10px;">
        <div class="h-100 d-flex flex-column">
          <div class="row col-lg-12">
            <div class="col-lg-2">
              <br />
              <br />
              <br />
              <button
                class="btn btn-sm btn-markets"
                style="width: 100px;"
                @click="CreateReport"
              >
                Create Report
              </button>
              <br />
              <button
                class="btn btn-sm btn-markets"
                style="width: 100px;"
                @click="getListReport('All')"
              >
                All Reports
              </button>
              <br />
              <button
                class="btn btn-sm btn-markets"
                style="width: 100px;"
                @click="getListReport('Public')"
              >
                Public Reports
              </button>
              <br />
              <button
                class="btn btn-sm btn-markets"
                style="width: 100px;"
                @click="getListReport('Private')"
              >
                Private Reports
              </button>
              <br />
              <button
                class="btn btn-sm btn-markets"
                style="width: 100px;"
                @click="getListReport('Drafts')"
              >
                Drafts Reports
              </button>
              <br />
              <button
                class="btn btn-sm btn-markets"
                style="width: 100px;"
                @click="getListReport('Inactive')"
              >
                Inactive Reports
              </button>
            </div>

            <div class="col-lg-10">
              <div class="row f-row">
                <div class="col col-12">
                  <table
                    class="table table-sm table-borderless table-data-controls"
                    style="width: 100%;"
                  >
                    <tbody>
                      <tr>
                        <td style="width: 10%" class="txt-label-primary-3">
                          <v-text-field
                            dark
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                          >
                          </v-text-field>
                        </td>

                        <td
                          style="width: 7.5%"
                          class="txt-label-primary-3 text-right"
                        >
                          Filter by tag:
                        </td>
                        <td style="width: 8.5%" class="txt-label-primary-3">
                          <select
                            class="dropdown-form"
                            value="0"
                            v-model="selectedTag"
                            @change="onUserTagSelection"
                          >
                            <option
                              v-for="(value, index) in ListTags"
                              :key="index"
                              :value="value.id"
                            >
                              {{ value.name.toUpperCase() }}
                            </option>
                          </select>
                        </td>

                        <td style="width: 30%" class="txt-label-primary-3">
                          <v-pagination
                            dark
                            prev-icon="fa fa-chevron-left"
                            next-icon="fa fa-chevron-right"
                            v-model="page"
                            :length="pageCount"
                          >
                          </v-pagination>
                        </td>
                        <td
                          style="width: 5%"
                          class="txt-label-primary-3 text-left"
                        >
                          {{ page }} / {{ pageCount }}
                        </td>
                        <td
                          class="txt-label-primary-3 text-right"
                          style="width: 7.5%; padding-right: 5px"
                        >
                          Reports/page:
                        </td>
                        <td style="width: 3.5%" class="txt-label-primary-3">
                          <v-text-field
                            dark
                            :value="itemsPerPage"
                            type="number"
                            min="1"
                            max="1000"
                            @input="itemsPerPage = parseInt($event, 10)"
                          >
                          </v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <br />
              <br />
              <div class="row f-row h-100">
                <div class="col col-12 h-100 scrl80">
                  <div
                    class="card"
                    v-for="(report, index) in reports"
                    :value="index"
                    :key="report.id"
                    style="border-bottom: 1px solid var(--lightbackground)"
                  >
                    <div class="row f-row">
                      <div class="col col-2 text-center mt-3 mb-3">
                        <router-link
                          to=""
                          tag="img"
                          :src="report.img"
                          class="report-image mx-auto d-block"
                          alt=""
                          style="padding: 0; cursor: pointer;"
                        >
                        </router-link>
                      </div>
                      <div class="col col-9 mt-3 mb-3">
                        <div class="card-block px-2">
                          <h4
                            class="card-title mt-2"
                            style="color:var(--textactive)"
                          >
                            {{ report.title }}
                          </h4>
                          <p class="card-text">{{ report.summary }}</p>
                          <hr class="hr-report" />
                          <div class="row f-row">
                            <div class="col col-12">
                              <table
                                class="table table-condensed table-borderless table-data-controls"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      style="width: 30%"
                                      class="txt-label-primary-4"
                                    >
                                      Tag:
                                      <template v-for="value in report.tag">
                                        <template v-if="value !== ''">
                                          <template v-for="val in ListTags">
                                            <template
                                              v-if="val.id === parseInt(value)"
                                            >
                                              {{ val.name }},
                                            </template>
                                          </template>
                                        </template>
                                      </template>
                                    </td>
                                    <td
                                      style="width: 20%"
                                      class="txt-label-primary-4"
                                    >
                                      Publication date:
                                      {{ report.publication_date | formatDate }}
                                    </td>
                                    <td
                                      style="width: 15%"
                                      class="txt-label-primary-4"
                                    >
                                      {{ report.likes }}
                                      <i
                                        class="fa fa-thumbs-up"
                                        aria-hidden="true"
                                      ></i>
                                    </td>
                                    <td
                                      style="width: 15%"
                                      class="txt-label-primary-4"
                                    >
                                      State: {{ report.state }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col col-1 text-center mt-3 mb-3"
                        style="padding-top: 4%"
                      >
                        <button @click="showMenu(report.id)">
                          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        </button>
                        <template
                          v-if="optionmenu && seloptionreport === report.id"
                        >
                          <ul class="nav">
                            <li @click="editReport(report.id)"><a>Edit</a></li>
                            <li
                              v-if="
                                report.state !== 'DRAFT' &&
                                  report.state !== 'INACTIVE'
                              "
                              @click="stateChange(report.id, 'Inactive')"
                            >
                              <a>Inactive</a>
                            </li>
                            <li
                              v-if="
                                report.state === 'PRIVATE' ||
                                  report.state === 'INACTIVE'
                              "
                              @click="stateChange(report.id, 'Public')"
                            >
                              <a>Public</a>
                            </li>
                            <li
                              v-if="
                                report.state === 'PUBLIC' ||
                                  report.state === 'INACTIVE'
                              "
                              @click="stateChange(report.id, 'Private')"
                            >
                              <a>Private</a>
                            </li>
                            <li
                              v-if="report.state !== 'INACTIVE'"
                              @click="duplicate(report.id)"
                            >
                              <a>Duplicate</a>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import { apiService } from "@/_services";
import moment from "moment";
import Navbar from "@/components/Navbar.vue";
import { colorThemeVuex } from "@/_core/_helpers/_helpers";

export default {
  name: "AdminReport",
  components: {
    Navbar
  },
  data() {
    return {
      user: {},
      colorTheme: true, // true = dark, else light
      // ========= pagination and search variables ============ //
      page: 1,
      itemsPerPage: 3,
      search: "",
      selectedTag: 0,
      ListTags: [],
      allReports: [],

      seloptionreport: 0,
      optionmenu: false,
      stateFilter: ""
    };
  },
  created() {
    // get all local data
    try {
      this.user = this.$store.state.user.all.items;
      console.log("User", this.user);
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    this.getTags();
    //this.getAuthor();
    document.title = "AdminReports | QS";
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("MMM DD, YY");
      }
    }
  },
  watch: {
    itemsPerPage() {
      this.page = 1;
    }
  },
  computed: {
    reportsText() {
      // this will allow to search on defined fields
      return this.allReports.map(d => {
        return (
          d.title.toLowerCase() +
          " " +
          d.summary.toLowerCase() +
          " " +
          d.text.toLowerCase() +
          " " +
          d.publication_date
        );
      });
    },

    filteredReports() {
      let rep = this.allReports;
      //filter tag
      if (this.selectedTag > 0) {
        rep = rep.filter(d => {
          var searchTag = this.selectedTag.toString();
          if (d.tag.indexOf(searchTag) > -1) {
            return d;
          }
        });
      }
      // search filter (for title, summary, text, author, company, date)
      if (this.search.length > 0) {
        var search = this.search.toLowerCase();
        rep = rep.filter((d, i) => {
          if (this.reportsText[i].indexOf(search) > -1) {
            return d;
          }
        });
      }
      return rep;
    },

    reports() {
      // this variable will be rendered
      let rep = this.filteredReports.slice(
        this.itemsPerPage * (this.page - 1),
        Math.min(this.allReports.length, this.itemsPerPage * this.page)
      );
      return rep;
    },

    pageCount() {
      return Math.ceil(this.filteredReports.length / this.itemsPerPage);
    }
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.overview_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      // saveUserPreferences(this);
    },
    CreateReport: function() {
      router.push("/CreateReport");
    },
    rebootOptionReport: function() {
      this.seloptionreport = 0;
    },
    getTags: function() {
      this.rebootOptionReport();
      apiService.listTags().then(data => {
        if (data !== null || data !== undefined) {
          var response = JSON.parse(data);
          this.ListTags = response.map(resp => {
            return {
              id: resp.pk,
              name: resp.fields.tag_name
            };
          });
        }
        this.getListReport("All");
      });
    },
    getListReport: function(state) {
      this.rebootOptionReport();
      this.stateFilter = state;
      var DataReport = {
        UserId: this.user.pk_idusers,
        TypeState: state
      };
      apiService.listReportAdmin(DataReport).then(data => {
        if (data !== null || data !== undefined) {
          this.allReports = [];
          var response = JSON.parse(data);
          response.map(resp => {
            this.allReports.push({
              id: resp.pk_id_report,
              img: resp.img,
              tag:
                resp.tags !== null || resp.tags !== undefined
                  ? resp.tags.split(",")
                  : [],
              title: resp.title,
              summary: resp.summary,
              text: resp.text,
              publication_date: resp.publication_date,
              likes: resp.likes,
              state: resp.State
            });
          });
        } else {
          this.allReports = [];
        }
      });
    },
    showMenu: function(id) {
      this.optionmenu = !this.optionmenu;
      this.seloptionreport = id;
    },
    stateChange(idReport, state) {
      this.rebootOptionReport();
      var dataChange = {
        ReportId: idReport,
        stateChange: state
      };
      apiService.stateChange(dataChange).then(data => {
        console.log("data", data);
        this.getListReport(this.stateFilter);
      });
    },
    duplicate(idReport) {
      apiService.duplicateReport(idReport).then(data => {
        console.log("data", data);
        this.getListReport(this.stateFilter);
      });
    },
    editReport(idReport) {
      router.push("/EditReport/" + idReport);
    },
    onUserTagSelection() {
      console.log("tag selected");
    }
  }
};
</script>

<style type="text/css">
* {
  margin: 0;
  padding: 0;
}

#header {
  margin: auto;
  width: 500px;
  font-family: Arial, Helvetica, sans-serif;
}

ul,
ol {
  list-style: none;
}

.nav > li {
  float: left;
}

.nav li a {
  background-color: #000;
  color: #fff;
  text-decoration: none;
  padding: 10px 12px;
  display: block;
}

.nav li a:hover {
  background-color: #434343;
}

.nav li ul {
  display: none;
  position: absolute;
  min-width: 140px;
}

.nav li:hover > ul {
  display: block;
}

.nav li ul li {
  position: relative;
}

.nav li ul li ul {
  right: -140px;
  top: 0;
}
</style>
